import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicVmWareVCloudVdcPortalDetailsParamsRawI,
	type LWApiPublicVmWareVCloudVdcPortalDetailsResultRawI,
} from '@liquidweb-dev/club-sauce/public/vmWare/vCloud/vDC/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const VMWARE_VCLOUD_VDC_PORTAL_DETAILS_QUERY_KEY =
	'/vmWare/vCloud/vdc/portalDetails';

const useVmWareVCloudVdcPortalDetails = (
	params: LWApiPublicVmWareVCloudVdcPortalDetailsParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicVmWareVCloudVdcPortalDetailsResultRawI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [VMWARE_VCLOUD_VDC_PORTAL_DETAILS_QUERY_KEY, params],
		queryFn: () => api.vmWare.vCloud.vdc.apiRaw.portalDetails(params),
		...options,
	});

export default useVmWareVCloudVdcPortalDetails;
